import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nextProvider } from "react-i18next";
import { ApiError } from "./api/client";
import { loadRuntimeConfig } from "./api/base";
import { i18nInstance, setDocumentLanguage } from "./lib/i18n";
import { ToastProvider } from "@green-on-grey/ui-kit";
import { App } from "./app/App";
// the styles of the kit first: the screens of Nabu add their own classes after them (FTR.NAB.CMN-0005 R23)
import "@green-on-grey/ui-kit/styles.css";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      // 4xx answers are final; retry only network and server errors.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

setDocumentLanguage(i18nInstance.language);

// The API address (/config.json) is needed before the first request.
await loadRuntimeConfig();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nextProvider i18n={i18nInstance}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
